import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { ReactSortable } from "react-sortablejs";
import Masonry from "react-masonry-css";
import {
  Box,
  Divider,
  Drawer,
  Grid,
  IconButton,
  Stack,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/styles";
import { useSelector } from "react-redux";
import { SwiperSlide } from "swiper/react";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import ArticleIcon from "@mui/icons-material/Article";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import VSNBreadcrumbs from "../../../shared/VSNBreadcrumbs";
import VSNButton from "../../../shared/VSNButton";
import { AssessmentForAdminStyle } from "./AssessmentForAdminStyle";
import {
  FlashIcon,
  LockIcon,
  MenuIcon,
  OptionalIcon,
  RightRoundIcon,
} from "../../../shared/icon";
import VSNImage from "../../../shared/VSNImage";
import VSNTypography from "../../../shared/VSNTypography";
import { VSNSwiper } from "../../../shared/VSNSwiper";
import { colorFromResults, toggleModelShow } from "../../../shared/CustomFunc";
import halfRound from "../../../assets/Teams/svg/half-round.svg";
import lightBlueLeaf from "../../../assets/Teams/svg/lightBlue-leaf.svg";
import cloud from "../../../assets/Teams/svg/cloud.svg";
import greenCloud from "../../../assets/Teams/svg/green-cloud.svg";
import VSNLoader from "../../../shared/VSNLoader";
import adminAssessment from "../../../container/org-admin/adminAssessment.container";
import { formatName } from "../../../utils/javascript";
import VSNConfirmBox from "../../../shared/VSNConfirmBox";
import allReportsViewContainer from "../../../container/allReports.container";
import VasanaOnePagerResult from "../../assessment/VasanaOnePagerResult";
import IntroExtroResult from "../../assessment/IntroExtroResult";
import OnePagerResult from "../../assessment/OnePagerResult";
import ProQOLResult from "../../assessment/ProQOLResult";
import XRayDashboardResult from "../../assessmentsView/physicalAssessment/XRayDashboardResult";
import AnswerSummaryResult from "../../assessment/AnswerSummaryResult";
import MRFDashboardResult from "../../assessmentsView/physicalAssessment/MRFDashboardResult";
import PhysicalExaminationResult from "../../assessmentsView/physicalAssessment/PhysicalExaminationResult";
import VitalsResult from "../../assessmentsView/physicalAssessment/VitalsResult";
import CPETDashboardResult from "../../assessmentsView/physicalAssessment/CPETDashboard/CPETDashboardResult";
import UltraSoundPoliceResult from "../../assessmentsView/physicalAssessment/UltraSoundPoliceResult";
import { ApiContainer } from "../../../utils/api";
import DashBoard from "../../assessment/DashBoard";
import VSNModel from "../../../shared/VSNModel";
import ViewUserDocumentListModal from "./ViewUserDocumentListModal";

const filteredAssessment = ["29"];

const AssessmentForAdmin = () => {
  const { api } = ApiContainer();
  const classes = AssessmentForAdminStyle();
  const navigate = useNavigate();

  const {
    AssessmentResult,
    AssessmentReportLoader,
    locationId,
    userId,
    releaseAllAssessment,
    releaseAllLoader,
    assessmentUserInfo,
    permissions,
    dialogBox,
    setDialogBox,
    handelSendWelcomeEmail,
    loaderSendWelcomeEmail,
    dispatch,
    modelState,
    documentReportList,
    documentReportListLoader,
    documentDownloaded,
    handleDocumentDownload,
  } = adminAssessment();

  const [assessmentResult, setAssessmentResult] = useState([]);

  useEffect(() => {
    if (AssessmentResult && AssessmentResult?.length) {
      setAssessmentResult(
        AssessmentResult?.filter(
          ({ assessment_id }) =>
            !filteredAssessment?.includes(String(assessment_id))
        )?.map(({ assessment_id, name, is_locked }) => ({
          assessment_id,
          name,
          is_locked,
        }))
      );
    }
  }, [AssessmentResult]);
  const theme = useTheme();
  const { result, loading } = allReportsViewContainer({
    userId,
    assessmentResult,
  });

  const [showReleaseButton, setShowReleaseButton] = useState(false);
  const [showAllReports, setShowAllReports] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const selectedAssessment = assessmentResult?.[activeSlide];
  const selectedResult =
    result?.[selectedAssessment?.assessment_id]?.data ?? {};
  const { organization_original_id } =
    useSelector((state) => state?.app?.userData?.user_profile) ?? {};

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const releaseAssessment = async () => {
    const data = await api({
      method: "POST",
      endPoint: `organization/${organization_original_id}/locations/${locationId}/members/${userId}/assessments/${selectedAssessment?.assessment_id}/release`,
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "assessmentResult",
    });

    if (data?.status) {
      setAssessmentResult((prev) =>
        prev.map((item) =>
          item.assessment_id === selectedAssessment.assessment_id
            ? { ...item, is_locked: false }
            : item
        )
      );
    }
  };

  const releaseButton = (
    <>
      {permissions?.user_assessments?.includes("release") && (
        <VSNButton
          handleClick={releaseAssessment}
          className={classes.releaseButton}
          variant="outlined"
        >
          <Stack direction="row" alignItems="center" gap={1}>
            <LockOpenIcon />
            Release
          </Stack>
        </VSNButton>
      )}
    </>
  );

  const getAssessmentResultComponent = (assessmentId, assessmentResult) => {
    switch (assessmentId.toString()) {
      case "1":
        return (
          <VasanaOnePagerResult
            viewAllResult={assessmentResult}
            from="viewAll"
          />
        );
      case "2":
        return (
          <IntroExtroResult viewAllResult={assessmentResult} from="viewAll" />
        );
      case "3":
      case "4":
      case "5":
      case "7":
      case "8":
      case "9":
        return (
          <OnePagerResult
            viewAllResult={assessmentResult}
            from="viewAll"
            releaseButton={releaseButton}
          />
        );
      case "6":
        return <ProQOLResult viewAllResult={assessmentResult} from="viewAll" />;
      case "10":
      case "11":
      case "12":
      case "13":
      case "14":
      case "15":
      case "19":
      case "20":
      case "21":
      case "22":
      case "23":
      case "24":
        return (
          <AnswerSummaryResult
            viewAllResult={assessmentResult}
            from="viewAll"
          />
        );
      case "16":
        return (
          <XRayDashboardResult
            viewAllResult={assessmentResult}
            from="viewAll"
            assessmentUserInfo={assessmentUserInfo}
          />
        );
      case "17":
        return (
          <MRFDashboardResult
            viewAllResult={assessmentResult}
            from="viewAll"
            assessmentUserInfo={assessmentUserInfo}
          />
        );
      case "18":
        return (
          <PhysicalExaminationResult
            viewAllResult={assessmentResult}
            from="viewAll"
            assessmentUserInfo={assessmentUserInfo}
          />
        );
      case "25":
        return (
          <VitalsResult
            viewAllResult={assessmentResult}
            from="viewAll"
            assessmentUserInfo={assessmentUserInfo}
          />
        );
      case "26":
        return (
          <CPETDashboardResult
            viewAllResult={assessmentResult}
            from="viewAll"
            assessmentUserInfo={assessmentUserInfo}
          />
        );
      case "27":
      case "28":
        return (
          <UltraSoundPoliceResult
            viewAllResult={assessmentResult}
            from="viewAll"
            assessmentUserInfo={assessmentUserInfo}
          />
        );

      default:
        return <DashBoard />;
    }
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    const prevIndex =
      activeSlide === 0
        ? AssessmentResult?.allResults?.length - 1
        : activeSlide - 1;
    setActiveSlide(prevIndex);
  };

  const handleNext = (e) => {
    e.stopPropagation();
    const nextIndex =
      activeSlide === AssessmentResult?.allResults?.length - 1
        ? 0
        : activeSlide + 1;
    setActiveSlide(nextIndex);
  };

  const handleSlideChange = (swiper) => {
    setActiveSlide(swiper?.activeIndex);
  };

  const breadcrumbsRoutes = [
    {
      path: "/org-admin?fromTo=members",
      label: `Members`,
    },
    {
      // path: `/org-admin/${locationId}/${userId}`,
      label: assessmentUserInfo?.name
        ? `${formatName(assessmentUserInfo?.name ?? "")}`
        : assessmentUserInfo?.email ?? "Username",
    },
  ];

  const statusBtn = ({ status, isRequired, classes, disable }) => {
    if (status === "COMPLETED") {
      return (
        <VSNButton
          className={classes.btnComplete}
          sx={{ cursor: disable ? "not-allowed" : "pointer", ml: "auto" }}
        >
          <RightRoundIcon />
          Completed
        </VSNButton>
      );
    }
    if (isRequired) {
      return (
        <VSNButton
          className={classes.btnRequired}
          sx={{ cursor: disable ? "not-allowed" : "pointer" }}
        >
          <FlashIcon />
          Required
        </VSNButton>
      );
    }
    if (!isRequired) {
      return (
        <VSNButton
          className={classes.btnRequired}
          sx={{ cursor: disable ? "not-allowed" : "pointer" }}
        >
          <OptionalIcon />
          Optional
        </VSNButton>
      );
    }
    return "";
  };

  const buttonTextForStatus = (status) => {
    if (status === "COMPLETED") {
      return "See full report";
    }
    if (status === "IGNORED") {
      return "Take Assessment";
    }
    return "";
  };

  const splitArray = (str) => {
    const data = str?.map((obj) =>
      obj?.includes(" ") ? splitArray(obj?.split(" ")) : obj
    );
    return data;
  };

  const breakpointCols = {
    default: 4,
    1440: 3,
    1200: 2,
    750: 1,
  };

  const SidebarContent = (
    <Box
      width="300px"
      p={2}
      sx={{
        borderRadius: 4,
        background: "#FCFCFD",
        boxShadow: "0px 7.7982px 17.32934px 0px rgba(81, 125, 132, 0.07)",
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          width: 8,
          padding: 4,
        },
        "&::-webkit-scrollbar-thumb": {
          borderRadius: 6,
          background: "#D5B98B",
          border: "1px solid #ffffff",
        },
      }}
    >
      <ReactSortable
        list={assessmentResult}
        setList={setAssessmentResult}
        animation={200}
        delay={2}
        ghostClass="sortable-ghost"
      >
        {assessmentResult.map((assessment, index) => (
          <Box
            key={assessment.assessment_id}
            className={classes.assessmentName}
            onClick={() => {
              setActiveSlide(index);
              if (isMobile) setDrawerOpen(false);
            }}
            sx={{
              cursor: "pointer",
              color: activeSlide === index ? "#86650A" : "#424450",
              backgroundColor:
                activeSlide === index ? "#E8D0B1" : "transparent",
              "&:hover": {
                backgroundColor: "#F1E1CD",
              },
            }}
          >
            <VSNTypography variant="body1" fontWeight="500">
              {assessment.name}
            </VSNTypography>
          </Box>
        ))}
      </ReactSortable>
    </Box>
  );

  useEffect(() => {
    if (AssessmentResult) {
      setShowReleaseButton(
        AssessmentResult?.find(({ is_locked }) => is_locked)
      );
    } else {
      setShowReleaseButton(false);
    }
  }, [AssessmentResult]);

  const handleDocumentOpen = async (lab_report_link) => {
    if (lab_report_link) {
      window.open(lab_report_link, "_blank");
    }
  };

  return (
    <div
      className={`${classes.mainLayout} ${showAllReports ? "innerLayout" : ""}`}
    >
      {AssessmentReportLoader ? (
        <Grid
          item
          lg={12}
          md={12}
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <VSNLoader variant="fullPage" />
        </Grid>
      ) : (
        <>
          <Box
            // mt={-2}
            className={classes.headingButton}
          >
            <Stack>
              <VSNBreadcrumbs {...{ breadcrumbsRoutes }} />
              <VSNTypography className={classes.heading}>
                {assessmentUserInfo
                  ? assessmentUserInfo?.name
                    ? `${formatName(assessmentUserInfo?.name ?? "")} `
                    : assessmentUserInfo?.email ?? "Username"
                  : "User’s Name"}
                : Assessment Reports
              </VSNTypography>
            </Stack>

            <Stack
              direction="row"
              flexWrap="wrap"
              ml="auto"
              justifyContent="flex-end"
              gap={{ xts: 2 }}
            >
              {selectedAssessment?.is_locked && showAllReports && releaseButton}

              {assessmentResult?.length > 0 && (
                <VSNButton
                  disabled={loading}
                  isLoading={loading}
                  handleClick={() => setShowAllReports(!showAllReports)}
                  className={classes?.releaseButton}
                  variant="outlined"
                >
                  {showAllReports ? " Card View" : "View All Reports"}
                </VSNButton>
              )}

              {permissions?.user_documents?.includes("view") && (
                <VSNButton
                  handleClick={() =>
                    dispatch(toggleModelShow("ViewUploadUserDocumnetList"))
                  }
                  isLoading={releaseAllLoader}
                  className={classes?.releaseButton}
                  variant="outlined"
                  startIcon={<ArticleIcon />}
                >
                  View Documents
                </VSNButton>
              )}

              {permissions?.member?.includes("send_welcome_mail") && (
                <VSNButton
                  handleClick={() => setDialogBox(!dialogBox)}
                  isLoading={releaseAllLoader}
                  className={classes?.releaseButton}
                  variant="outlined"
                  startIcon={<ForwardToInboxIcon />}
                >
                  Send Invite
                </VSNButton>
              )}

              {showReleaseButton &&
                permissions?.user_assessments?.includes("release_all") && (
                  <VSNButton
                    handleClick={releaseAllAssessment}
                    isLoading={releaseAllLoader}
                    className={classes?.releaseButton}
                  >
                    Release All
                  </VSNButton>
                )}
            </Stack>
          </Box>

          {showAllReports && assessmentResult?.length ? (
            <Box
              className={`${classes.mainLayout}`}
              p={0}
              display={{ md: "flex" }}
              flexDirection={{ md: "row" }}
              height="100%"
            >
              {isMobile ? (
                <>
                  <IconButton
                    onClick={toggleDrawer}
                    sx={{
                      backgroundColor: "var(--primary)",
                      color: "var(--white)",
                      borderRadius: 1,
                      mb: 2,
                      width: "max-content",
                      "&:hover": {
                        backgroundColor: "var(--primaryDarker)",
                      },
                    }}
                  >
                    <MenuIcon />
                  </IconButton>

                  <Drawer
                    anchor="left"
                    open={drawerOpen}
                    onClose={toggleDrawer}
                    ModalProps={{ keepMounted: true }}
                    slotProps={{
                      root: {
                        sx: {
                          "& .MuiPaper-root": {
                            top: 64,
                          },
                        },
                      },
                    }}
                  >
                    {SidebarContent}
                  </Drawer>
                </>
              ) : (
                SidebarContent
              )}

              <Box flex={1} overflow="auto" className={classes.outerWrapper}>
                {getAssessmentResultComponent(
                  selectedAssessment?.assessment_id,
                  selectedResult
                )}
              </Box>
            </Box>
          ) : (
            <Masonry
              breakpointCols={breakpointCols}
              className={classes.masonryGrid}
              columnClassName="my-masonry-grid_column"
            >
              {AssessmentResult?.length ? (
                AssessmentResult?.map(
                  (
                    {
                      name,
                      status,
                      is_required: isRequired,
                      result,
                      // handleButtonClick,
                      assessment_id: assessmentId,
                      type,
                      retakeAssessment,
                      userRoleData,
                      assessment_taken: assessmentTaken,
                      all_results: allResults,
                      is_locked,
                      lab_report_link,
                      submission_date,
                    },
                    index
                  ) => {
                    return (
                      <Stack
                        key={index}
                        className={classes.assessmentCard}
                        sx={{
                          cursor: lab_report_link ? "not-allowed" : "pointer",
                          "&:before": {
                            position: "absolute",
                            content: "''",
                            inset: -2,
                            background: `linear-gradient(to right,${colorFromResults(
                              result
                            )} 50%,#F8DEFF 80%)`,
                            borderRadius: "11px",
                            zIndex: -1,
                            opacity: 0,
                          },
                        }}
                        onClick={() => {
                          if (!lab_report_link) {
                            navigate(
                              `/org-admin/${locationId}/${userId}/${assessmentId}`
                            );
                          }
                        }}
                        // handleClick={(e) => {
                        //   e.stopPropagation();
                        //   handleButtonClick(
                        //     name,
                        //     assessmentId,
                        //     type,
                        //     assessmentTaken
                        //   );
                        // }}
                      >
                        {index % 2 === 0 ? (
                          <>
                            <VSNImage
                              src={halfRound}
                              alt="halfRound"
                              className={classes.halfRound}
                            />
                            <VSNImage
                              src={cloud}
                              alt="cloud"
                              className={classes.cloud}
                            />
                          </>
                        ) : (
                          <>
                            <VSNImage
                              src={greenCloud}
                              alt="greenCloud"
                              className={classes.greenCloud}
                            />
                            <VSNImage
                              src={lightBlueLeaf}
                              alt="lightBlueLeaf"
                              className={classes.lightBlueLeaf}
                            />
                          </>
                        )}
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          flexWrap="wrap"
                        >
                          <VSNTypography
                            variant="h3"
                            className={classes.mdHeading}
                            mb="0"
                          >
                            {name}
                          </VSNTypography>
                          {statusBtn({
                            status,
                            isRequired,
                            classes,
                            disable: assessmentTaken,
                          })}
                        </Stack>
                        <Divider
                          sx={{ marginTop: 2, borderColor: "#EAEDF0" }}
                        />
                        {allResults?.length > 1 ? (
                          <VSNSwiper
                            className={classes.assessmentCardSlider}
                            pagination={{
                              type: "fraction",
                            }}
                            navigation={{
                              nextEl: ".swiper-button-next",
                              prevEl: ".swiper-button-prev",
                              disabledClass: "swiper-button-disabled",
                            }}
                            onSlideChange={handleSlideChange}
                            initialSlide={activeSlide}
                          >
                            {allResults?.length > 1 && (
                              <>
                                <Stack
                                  className="swiper-button-next"
                                  onClick={handleNext}
                                />
                                <Stack
                                  className="swiper-button-prev"
                                  onClick={handlePrev}
                                />
                              </>
                            )}
                            {allResults?.map((el, ind) => {
                              return (
                                <SwiperSlide key={ind}>
                                  <VSNTypography
                                    fontSize={{ sm: 18, xs: 16 }}
                                    fontWeight={500}
                                    color="var(--primary)"
                                    mt={2}
                                    pr={7}
                                  >
                                    {el?.category}
                                  </VSNTypography>
                                  <Stack className={classes.imgWrapper} mb={2}>
                                    <VSNImage
                                      src={el?.image}
                                      alt="assessment1"
                                    />
                                  </Stack>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: el?.result,
                                    }}
                                  />
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: el?.trait_description,
                                    }}
                                  />
                                </SwiperSlide>
                              );
                            })}
                          </VSNSwiper>
                        ) : (
                          <>
                            <VSNTypography
                              fontSize={{ sm: 18, xs: 16 }}
                              fontWeight={500}
                              color="var(--primary)"
                              mt={2}
                              pr={7}
                            >
                              {allResults?.[0]?.category}
                            </VSNTypography>
                            <Stack className={classes.imgWrapper} mb={2}>
                              <VSNImage
                                src={allResults?.[0]?.image}
                                alt="assessment1"
                              />
                            </Stack>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: allResults?.[0]?.result,
                              }}
                            />
                            <div
                              dangerouslySetInnerHTML={{
                                __html: allResults?.[0]?.trait_description,
                              }}
                            />
                          </>
                        )}

                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Stack
                            direction={{ xs: "column", sm: "row" }}
                            spacing="20px"
                          >
                            {status &&
                            status === "COMPLETED" &&
                            lab_report_link === null ? (
                              <VSNButton
                                variant="outlined"
                                className={classes.outLinedBtn}
                                // handleClick={(e) => {
                                //   e.stopPropagation();
                                //   handleButtonClick(
                                //     name,
                                //     assessmentId,
                                //     type,
                                //     assessmentTaken
                                //   );
                                // }}
                                startIcon={is_locked && <LockIcon />}
                              >
                                {is_locked
                                  ? "Unlock Assessment"
                                  : buttonTextForStatus(status)}
                              </VSNButton>
                            ) : null}

                            {status &&
                            status === "COMPLETED" &&
                            lab_report_link ? (
                              <VSNButton
                                variant="outlined"
                                className={classes.outLinedBtn}
                                handleClick={(e) => {
                                  e.stopPropagation();
                                  handleDocumentOpen(lab_report_link);
                                }}
                                startIcon={is_locked && <LockIcon />}
                              >
                                {/* {is_locked
                              ? "Unlock Assessment"
                              : "download report"} */}

                                {lab_report_link ? "Download Labs Report" : ""}
                              </VSNButton>
                            ) : null}

                            {assessmentTaken && userRoleData?.is_demo_user ? (
                              <VSNButton
                                className={classes.outLinedBtn}
                                handleClick={(e) => {
                                  e.stopPropagation();
                                  retakeAssessment(assessmentId, type);
                                }}
                              >
                                Retake Assessment
                              </VSNButton>
                            ) : null}
                          </Stack>

                          {submission_date &&
                          status === "COMPLETED" &&
                          assessmentId === 11 ? (
                            <Stack
                              sx={{
                                backgroundColor: "#F2E7F5",
                                padding: "4px 10px",
                                borderRadius: 1,
                              }}
                            >
                              <VSNTypography fontSize="12px" fontWeight={400}>
                                Submission Date
                              </VSNTypography>
                              <VSNTypography fontSize="14px" fontWeight={500}>
                                {dayjs(submission_date).format("MM/DD/YYYY")}
                              </VSNTypography>
                            </Stack>
                          ) : null}
                        </Stack>
                      </Stack>
                    );
                  }
                )
              ) : (
                <Stack>No assessments found</Stack>
              )}
            </Masonry>
          )}
        </>
      )}

      {dialogBox && (
        <VSNConfirmBox
          isOpen={dialogBox}
          title="Are You Sure?"
          handleOk={() => handelSendWelcomeEmail(setDialogBox)}
          handleCancel={() => setDialogBox(false)}
          setDialogBox={setDialogBox}
          okBtnName="Send Email"
          cancelBtnName="Cancel"
          isLoading={loaderSendWelcomeEmail}
          className={classes.conformModel}
          msg={
            <>
              “Are you sure you would like to send a Welcome Email to{" "}
              <span>{assessmentUserInfo?.name ?? ""}</span>
              at email address: <span>{assessmentUserInfo?.email}</span>
            </>
          }
        />
      )}

      {modelState?.ViewUploadUserDocumnetList && (
        <VSNModel
          open={modelState?.ViewUploadUserDocumnetList}
          onClose={() => {
            dispatch(toggleModelShow("ViewUploadUserDocumnetList"));
          }}
          disableEnforceFocus
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          mobileDrawer
          className={classes.inviteAdminModel}
        >
          <ViewUserDocumentListModal
            dispatch={dispatch}
            documentReportList={documentReportList}
            documentReportListLoader={documentReportListLoader}
            documentDownloaded={documentDownloaded}
            handleDocumentDownload={handleDocumentDownload}
          />
        </VSNModel>
      )}
    </div>
  );
};

export default AssessmentForAdmin;
